var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { PopupSurveyModel } from "survey-core";
import { Survey } from "./reactSurvey";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var PopupSurvey = /** @class */ (function (_super) {
    __extends(PopupSurvey, _super);
    function PopupSurvey(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnExpanded = _this.handleOnExpanded.bind(_this);
        return _this;
    }
    PopupSurvey.prototype.getStateElements = function () {
        return [this.popup, this.popup.survey];
    };
    PopupSurvey.prototype.handleOnExpanded = function (event) {
        this.popup.changeExpandCollapse();
    };
    PopupSurvey.prototype.canRender = function () {
        return _super.prototype.canRender.call(this) && this.popup.isShowing;
    };
    PopupSurvey.prototype.renderElement = function () {
        var _this = this;
        var header = this.renderWindowHeader();
        var body = this.renderBody();
        var style = {};
        if (!!this.popup.renderedWidth) {
            style.width = this.popup.renderedWidth;
            style.maxWidth = this.popup.renderedWidth;
        }
        return (React.createElement("div", { className: this.popup.cssRoot, style: style, onScroll: function () { return _this.popup.onScroll(); } },
            React.createElement("div", { className: this.popup.cssRootContent },
                header,
                body)));
    };
    PopupSurvey.prototype.renderWindowHeader = function () {
        var popup = this.popup;
        var headerCss = popup.cssHeaderRoot;
        var titleCollapsed = null;
        var expandCollapseIcon;
        var closeButton = null;
        var allowFullScreenButon = null;
        if (popup.isCollapsed) {
            headerCss += " " + popup.cssRootCollapsedMod;
            titleCollapsed = this.renderTitleCollapsed(popup);
            expandCollapseIcon = this.renderExpandIcon();
        }
        else {
            expandCollapseIcon = this.renderCollapseIcon();
        }
        if (popup.allowClose) {
            closeButton = this.renderCloseButton(this.popup);
        }
        if (popup.allowFullScreen) {
            allowFullScreenButon = this.renderAllowFullScreenButon(this.popup);
        }
        return (React.createElement("div", { className: popup.cssHeaderRoot },
            titleCollapsed,
            React.createElement("div", { className: popup.cssHeaderButtonsContainer },
                allowFullScreenButon,
                React.createElement("div", { className: popup.cssHeaderCollapseButton, onClick: this.handleOnExpanded }, expandCollapseIcon),
                closeButton)));
    };
    PopupSurvey.prototype.renderTitleCollapsed = function (popup) {
        if (!popup.locTitle)
            return null;
        return React.createElement("div", { className: popup.cssHeaderTitleCollapsed }, popup.locTitle.renderedHtml);
    };
    PopupSurvey.prototype.renderExpandIcon = function () {
        return React.createElement(SvgIcon, { iconName: "icon-restore_16x16", size: 16 });
    };
    PopupSurvey.prototype.renderCollapseIcon = function () {
        return React.createElement(SvgIcon, { iconName: "icon-minimize_16x16", size: 16 });
    };
    PopupSurvey.prototype.renderCloseButton = function (popup) {
        var _this = this;
        return (React.createElement("div", { className: popup.cssHeaderCloseButton, onClick: function () {
                popup.hide();
                if (typeof _this.props.onClose == "function") {
                    _this.props.onClose();
                }
            } },
            React.createElement(SvgIcon, { iconName: "icon-close_16x16", size: 16 })));
    };
    PopupSurvey.prototype.renderAllowFullScreenButon = function (popup) {
        var Icon;
        if (popup.isFullScreen) {
            Icon = React.createElement(SvgIcon, { iconName: "icon-back-to-panel_16x16", size: 16 });
        }
        else {
            Icon = React.createElement(SvgIcon, { iconName: "icon-full-screen_16x16", size: 16 });
        }
        return (React.createElement("div", { className: popup.cssHeaderFullScreenButton, onClick: function () { popup.toggleFullScreen(); } }, Icon));
    };
    PopupSurvey.prototype.renderBody = function () {
        return React.createElement("div", { className: this.popup.cssBody }, this.doRender());
    };
    PopupSurvey.prototype.createSurvey = function (newProps) {
        if (!newProps)
            newProps = {};
        _super.prototype.createSurvey.call(this, newProps);
        this.popup = new PopupSurveyModel(null, this.survey);
        if (newProps.closeOnCompleteTimeout) {
            this.popup.closeOnCompleteTimeout = newProps.closeOnCompleteTimeout;
        }
        this.popup.allowClose = newProps.allowClose;
        this.popup.allowFullScreen = newProps.allowFullScreen;
        this.popup.isShowing = true;
        if (!this.popup.isExpanded && (newProps.expanded || newProps.isExpanded))
            this.popup.expand();
    };
    return PopupSurvey;
}(Survey));
export { PopupSurvey };
/**
 * @deprecated Use `PopupSurvey` instead.
 */
var SurveyWindow = /** @class */ (function (_super) {
    __extends(SurveyWindow, _super);
    function SurveyWindow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SurveyWindow;
}(PopupSurvey));
export { SurveyWindow };
